import { render } from "./Politic.vue?vue&type=template&id=7b47f730&scoped=true"
import script from "./Politic.vue?vue&type=script&lang=js"
export * from "./Politic.vue?vue&type=script&lang=js"

import "./Politic.vue?vue&type=style&index=0&id=7b47f730&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b47f730"]])

export default __exports__